import determineTarget from './determine-target';
import setupFocusTrap from './focus-trap';
import toggleElement from './toggle-element';

const modalTriggers = new WeakMap();

export default function setupModals() {
	// Initialize all dialog elements
	document.querySelectorAll( '.js-modal' ).forEach( dialog => {
		// Set necessary attributes
		dialog.tabIndex = -1;
		dialog.setAttribute( 'role', 'dialog' );
		dialog.setAttribute( 'aria-hidden', true );

		// Trap focus within
		setupFocusTrap( dialog );
	} );

	// Handle opening the modal from a button that controls it
	document.addEventListener( 'click', event => {
		const toggle = event.target.closest( '[aria-controls], [data-target]' );

		// Skip if it doesn't control anything
		if ( ! toggle || ( ! toggle.hasAttribute( 'aria-controls' ) && ! toggle.dataset.target ) ) {
			return;
		}

		// Skip if the target isn't a dialog
		const target = determineTarget( toggle );
		if ( ! target || ! target.classList.contains( 'js-modal' ) ) {
			return;
		}

		event.preventDefault();

		// Open and focus the dialog
		toggleElement( target, true, 'focus' );

		// Record the trigger for refocusing later
		modalTriggers.set( target, toggle );
	} );

	// Handle closing the modal, by clicking the close button or backdrop
	document.addEventListener( 'click', ( { target } ) => {
		if ( ! target.classList.contains( 'js-modal-close' ) && ! target.classList.contains( 'js-modal-backdrop' ) ) {
			return;
		}

		// Find the parent dialog
		const modal = target.closest( '.js-modal' );
		if ( ! modal ) {
			return;
		}

		// Close the dialog
		toggleElement( modal, false );

		// Refocus the trigger if found
		if ( modalTriggers.has( modal ) ) {
			modalTriggers.get( modal ).focus();
		}
	} );

	// Handle closing the modal via ESC key
	document.addEventListener( 'keyup', ( { key, target } ) => {
		if ( key !== 'Escape' ) {
			return;
		}

		// Find the parent dialog
		const modal = target.closest( '.js-modal' );
		if ( ! modal ) {
			return;
		}

		// Close the dialog
		toggleElement( modal, false );

		// Refocus the trigger if found
		if ( modalTriggers.has( modal ) ) {
			modalTriggers.get( modal ).focus();
		}
	} );
}
